import btnZoomIn from "../../../../images/contents/map/livecamera/bt_zoomIn.png";
import btnZoomOut from "../../../../images/contents/map/livecamera/bt_zoomOut.png";
import btnClose from "../../../../images/contents/map/livecamera/btn_close.png";
import brokenImg from "../../../../images/contents/map/livecamera/broken_img.png";
import { translation } from "../../../../utils/FPEUtils";

const cameraIcon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFZSURBVHgB7dQ/T8JAFADw9wB33WAwKfEDUL4Bkuhq0RnCqrMxhTBAQsBIgptxgoSFjdZJ41Cd7Eg32GxiohCG1sQYTITzuhqvXpM6qPcb2rvc+7fcAQiCIPx3yDpQ46oEGO3SiAzwIsRevEOuNWtYvCkx1gFGolqmkJGz+SzwMno3ktEzqnSpeHs1Xi4ShB0kYB1PGrWvciKsYgQgUHNPejsNiJDyGquJ8r0kJ7t7R7sK7VJk5cQgRGvxVfpFSZKlbrawCclUEpyJ65sT6gCeg/N9SGwkuOMjELIgzX9kgKD+3gCD1gBMzeSOD32A0d0YLs+u9Ha+DcPr4bfxzAEQ0XWn/lfoM2fqwPxlbjcf6zl39pwbtDS7X+3TNwWZhXyuIal1Djun8lYaeI3NEX2NyYW3bj7UdfrTS9GK8va6csvKQb+CpfWKQhZLGTgtCbFOnpo6CIIg/CYfZtJpwSmZH6AAAAAASUVORK5CYII=";
const cameraIconNoDir =
  "data:image/png;base64,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";

export const configSoraCameDh = {
  Controller: {
    Name: "SoraCame",
    update_interval: 60,
    request_timeout: 60,
    download_max: 16,
    min_request_interval: 2,
    image_data_limit: 256000000,
    max_window: 30,
    animation_time_range: 1800,
    image_time_range: 2592000,
  },
  Source: {
    CameraMaster: {
      Type: "JSON",
      url: "%soracame_api_url%/livecam/list.json",
      cache_busting: true,
    },
    ImageFileList: {
      Type: "JSON",
      url: "%soracame_image_list_api_url%/api/soracam/image_list?camera_id=%camera_id%",
      download_max: 32,
      cache_busting: true,
    },
    ImageFile: {
      Type: "Image",
      download_max: 32,
      url: "%soracame_api_url%/livecam/%camera_id%/640/%file%",
    },
    data: {
      Type: "Derived",
      retain: true,
    },
  },
};

export const configSoraCameLayer = {
  Name: "SoraCame",
  Renderer: "SoraCame",
  Attributes: {
    target_type: ["soracam"],
    date_format: "%month%/%day% %0hour%:%0min% UTC",
    timezone: {
      utc: {
        date_format: "%month%/%day% %0hour%:%0min% UTC",
      },
      "Asia/Tokyo": {
        date_format: "%local_month%/%local_day% %0local_hour%:%0local_min% JST",
      },
    },
    expire: {
      threshold: 3600,
      text: translation("Not updated for over 1 hours"),
      style: {
        color: "#FF0000",
      },
    },
    unavailable_message: translation("No image"),
    initial_icon_fadein: 0.0,
    initial_icon_fadeout: 2.0,
    icon_fadein: 0.5,
    icon_fadeout: 0.75,
    zoom_in_button: btnZoomIn,
    zoom_out_button: btnZoomOut,
    close_button: btnClose,
    error_image: brokenImg,
    mini_icon_zoom: 6,
    style: {
      default: {
        icon_overlap_margin: 8,
        icon: cameraIcon,
        unavailable_icon: cameraIcon,
        icon_width: 32,
        icon_height: 32,
        icon_offset_x: -16,
        icon_offset_y: -16,
        icon_nondir: cameraIconNoDir,
        icon_nondir_width: 24,
        icon_nondir_height: 24,
        icon_nondir_offset_x: -12,
        icon_nondir_offset_y: -12,
        mini_icon_overlap_margin: 4,
        mini_icon: cameraIcon,
        mini_unavailable_icon: cameraIcon,
        mini_icon_width: 24,
        mini_icon_height: 24,
        mini_icon_offset_x: -12,
        mini_icon_offset_y: -12,
        mini_icon_nondir: cameraIconNoDir,
        mini_icon_nondir_width: 16,
        mini_icon_nondir_height: 16,
        mini_icon_nondir_offset_x: -8,
        mini_icon_nondir_offset_y: -8,
      },
    },
  },
};
